import { isNullOrEmpty } from "../../../../../../../../Common/TypingUtils";

export interface LevelAbbreviations {
    short: string;
    long: string;
    fiasKey: string | number;
    engName?: string;
    objectID?: string;
}

export enum fiasConvertationToShowMethods {
    getRegionNameByCode = "getRegionNameByCode",
    getMunicipalDistrictTypeShortName = "getMunicipalDistrictTypeShortName",
    getUrbanSettlementTypeShortName = "getUrbanSettlementTypeShortName",
}

export enum fiasConvertationMethods {
    getFlatTypeShortName = "getFlatTypeShortName",
    getFlatTypeLongName = "getFlatTypeLongName",
    getRoomTypeLongName = "getRoomTypeLongName",
    getRoomTypeShortName = "getRoomTypeShortName",
    getHouseTypeShortName = "getHouseTypeShortName",
    getHouseTypeLongName = "getHouseTypeLongName",
    getHouseTypeObjectID = "getHouseTypeObjectID",
    getFlatTypeObjectID = "getFlatTypeObjectID",
    getMunicipalDistrictTypeCode = "getMunicipalDistrictTypeCode",
    getMunicipalDistrictTypeCodeWithFT = "getMunicipalDistrictTypeCodeWithFT",
    getMunicipalDistrictTypeShortName = "getMunicipalDistrictTypeShortName",
    extractRegionCode = "extractRegionCode",
    extractOKTMO8Symbols = "extractOKTMO8Symbols",
    getUrbanSettlementTypeCode = "getUrbanSettlementTypeCode",
    getUrbanSettlementTypeShortName = "getUrbanSettlementTypeShortName",
    convertAbbreviationToShortName = "convertAbbreviationToShortName",
    convertAbbreviationToFullName = "convertAbbreviationToFullName",
}

export function isMatchAbbreviation(abbreviation: LevelAbbreviations, value: string | undefined): boolean {
    if (isNullOrEmpty(value)) {
        return false;
    }

    return (
        abbreviation.long === value ||
        abbreviation.short === value ||
        abbreviation.fiasKey === value ||
        abbreviation.engName === value
    );
}
